import { SignIn } from "@clerk/nextjs";

const SignInPage = () => <SignIn path="/sign-in" routing="path" signUpUrl="/sign-up"
  redirectUrl={typeof window !== "undefined" ? window.location.origin : undefined}
/>;

export default SignInPage;
